import 'lite-youtube-embed'
import 'lite-vimeo-embed/module/lite-vimeo-embed'

import 'virtual:svg-icons-register'
import.meta.glob('../img/**/*')

import '@splidejs/splide/css/core'
import 'glightbox/dist/css/glightbox.min.css'

import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import resize from '@alpinejs/resize'
import Dialog from '@alpinejs/ui/src/dialog'
import Tabs from '@alpinejs/ui/src/tabs'
import splide from './components/splide'
import productGallery from './components/productGallery'
import federatedSearch from './components/federatedSearch'
import eventTracking from './components/eventTracking'
import formTracking from './components/formTracking'
import directoryBrowse from './components/directoryBrowse'
import directoryZipSearch from './components/directoryZipSearch'
export function init() {
  window.Alpine = Alpine

  Alpine.plugin(focus)
  Alpine.plugin(intersect)
  Alpine.plugin(collapse)
  Alpine.plugin(resize)
  Alpine.plugin(Dialog)
  Alpine.plugin(Tabs)
  Alpine.data('splide', splide)
  Alpine.data('productGallery', productGallery)
  Alpine.data('federatedSearch', federatedSearch)
  Alpine.data('formTracking', formTracking)
  Alpine.data('directoryBrowse', directoryBrowse)
  Alpine.data('directoryZipSearch', directoryZipSearch)
  Alpine.start()

  eventTracking({
    dataLayerName: 'dataLayer',
    dataTargets: [{
      elementName: 'btn',
      selector: '[class~="btn"]',
    }],
  })
}

window.addEventListener('DOMContentLoaded', () => init(window.APP?.CONFIG || {}))

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
